import axios from '../../axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const token = localStorage.getItem('token');

export const createLoan = createAsyncThunk(
    'loans/createLoan',
    async (loanData, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/loans/create', loanData, {
                headers: {
                    'x-auth-token': token,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const editLoan = createAsyncThunk(
    'loans/editLoan',
    async (loanData, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/loans/edit', loanData, {
                headers: {
                    'x-auth-token': token,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const updateLoan = createAsyncThunk(
    'loans/updateLoan',
    async (loanData, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/loans/update', loanData, {
                headers: {
                    'x-auth-token': token,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const getLoans = createAsyncThunk(
    'loans/getLoans',
    async (username, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/loans/get', username, {
                headers: {
                    'x-auth-token': token,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const fetchLoans = createAsyncThunk(
    'loans/fetchLoans',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get('/api/loans/fetch', {
                headers: {
                    'x-auth-token': token,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const deleteLoan = createAsyncThunk(
    'loans/deleteLoan',
    async (_id, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/loans/delete', _id, {
                headers: {
                    'x-auth-token': token,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const Hash = createAsyncThunk(
    'loans/Hash',
    async (loanData, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/loans/hash', loanData, {
                headers: {
                    'x-auth-token': token,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
